import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Modal from "react-bootstrap/Modal";

import RangeSelector from "../global/filter/RangeSelector";

import { ReactComponent as FilterIcon } from "../../assets/filter.svg";

import Button from "../global/button";

import _ from "lodash";
import { roundNumberMax, roundNumberMin } from "../../utils/math";
import { generateListingUrl } from "../../utils/formatting/listing/url.utils";
import { generateDestinationListingUrl } from "../../utils/formatting/distinations-listing/url.utils";

const initialState = {
  price: [],
  starRating: [],
  review: [],
  policy: [],
  meals: [],
  propertyTypeIds: [],
};

const PropertyFilterModal = ({ filters, paramFilters, isDestinations = false, summary = {}, params: queryParams = {}, mapMobileFilter }) => {
  const [show, setShow] = useState(false);

  const { currency, exchange_rate } = useSelector((state) => state.user_preference);

  const [selectedFilters, setSelectedFilters] = useState(initialState);

  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const price = paramFilters.price || [];
    const review = paramFilters.score || [];
    const policy = paramFilters.policy || [];
    const propertyTypeIds = paramFilters.propertyTypeIds || [];
    const meals = paramFilters.meals || [];
    const deals = paramFilters.deals || [];
    const starRating = paramFilters?.starRating || [];

    setSelectedFilters({
      price,
      review,
      starRating,
      policy,
      propertyTypeIds,
      meals,
      deals,
    });
  }, []);

  function handleFilter() {
    const { starRating, review, policy, propertyTypeIds, meals } = selectedFilters;

    if (isDestinations) {
      const searchParams = new URLSearchParams(location.search);
      const sortType = searchParams.get("sortType");

      const { destination } = params;

      const selectedPropertyType = filters[0]?.items.find((item) => item.value === propertyTypeIds[0]);

      const url = generateDestinationListingUrl({
        searchCriteria: {
          location: {
            label: destination,
          },
        },
        filters: {
          starRating: Array.isArray(starRating) ? starRating : [], // Ensure starRating is an array
          propertyType: selectedPropertyType ? `${selectedPropertyType.name}s` : null,
        },
        sortType,
      });
      setShow(false);
      return navigate(url);
    }

    let price = selectedFilters.price || [];

    const filtersSelected = {
      minPrice: price[0],
      maxPrice: price[1],

      starRating: starRating,

      minReviewScore: review[0],
      maxReviewScore: review[1],
      cancelationPolicyTypes: policy,

      meals: meals,

      propertyTypeIds: propertyTypeIds,
    };

    const url = generateListingUrl({ params: queryParams, filters: filtersSelected });

    setShow(false);

    navigate(`${url}`);
  }

  function handleClear() {
    if (isDestinations) {
      const { destination } = params;
      const searchParams = new URLSearchParams(location.search);
      const sortType = searchParams.get("sortType");

      setSelectedFilters(initialState);

      const url = generateDestinationListingUrl({
        searchCriteria: {
          location: {
            label: destination,
          },
        },
        filters: {
          starRating: [],
          propertyType: null,
        },
        sortType,
      });

      navigate(url);
      setShow(false);
      setSelectedFilters(initialState);
      return;
    }

    const url = generateListingUrl({ params: queryParams, filters: {} });

    navigate(url);
    setShow(false);
    setSelectedFilters(initialState);
  }

  function handleCommitedChange(value, heading) {
    if (value[0] === value[1]) {
      return;
    }
    if (heading === "Your budget") {
      heading = "price";
    } else if (heading === "Review score") {
      heading = "review";
    }

    setSelectedFilters((prev) => {
      return { ...prev, [heading]: value };
    });
  }

  const minPrice = summary?.minPrice || 1;
  const maxPrice = summary?.maxPrice || 400;

  const selectedPriceRange = [selectedFilters.price[0] ?? minPrice, selectedFilters.price[1] ?? maxPrice];

  return (
    <>
      <button className="filter" aria-expanded={show} onClick={() => setShow(true)}>
        Filter <FilterIcon />{" "}
      </button>
      <Modal
        className={`property-filter-modal ${mapMobileFilter}`}
        show={show}
        onHide={() => {
          setShow(false);
        }}
        backdrop="true"
        keyboard={true}
        size="md"
        aria-labelledby="Property Filter Modal"
        centered
      >
        <Modal.Header>
          <div>
            <div class="modal-title h4">Filter by</div>
            <button type="button" class="global-button global-button--secondary global-button--sm clear-btn" onClick={handleClear}>
              Clear
            </button>

            <button
              type="button"
              class="btn-close"
              aria-label="Close"
              onClick={() => {
                setShow(false);
              }}
            ></button>
          </div>
          <p class="filter-description">Narrow your search down using filters</p>
        </Modal.Header>
        <Modal.Body>
          {!isDestinations && minPrice !== maxPrice && (
            <RangeSelector
              initialvalue={selectedPriceRange}
              heading="Your budget"
              min={minPrice}
              max={maxPrice}
              handleCommitedChange={handleCommitedChange}
            />
          )}

          {/* {minStar !== maxStar && (
            <RangeSelector
              initialvalue={selectedStarRange}
              heading="Star rating"
              min={minStar}
              max={maxStar}
              start={`${minStar} star`}
              end={`${maxStar} star`}
              handleCommitedChange={handleCommitedChange}
            />
          )} */}

          {/* {!isDestinations && minReview !== maxReview && (
          <RangeSelector
            initialvalue={selectedReviewRange}
            heading="Review score"
            min={minReview}
            max={maxReview}
            start={`${minReview} star`}
            end={`${maxReview} star`}
            handleCommitedChange={handleCommitedChange}
          />
        )} */}

          {filters.map((item, index) => {
            if (!item?.items?.length || !item.value || !item.title) return null;
            return (
              <CategoryFilter
                key={index}
                title={item.title}
                items={item.items}
                value={item.value}
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
                isSelectMultiple={!isDestinations}
              />
            );
          })}
          <div className="filter-button-wrapper">
            <div className="hide-background"></div>
            <div className="blur-line"></div>
            <Button onClick={handleFilter}>Filter</Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PropertyFilterModal;

function CategoryFilter({ title, items = [], value, selectedFilters, setSelectedFilters, isSelectMultiple = true }) {
  // function handleCheck(item, e) {
  //   const { checked } = e.target;

  //   if (checked) {
  //     setSelectedFilters((prev) => {
  //       return {
  //         ...prev,
  //         [value]: [...prev[value], item],
  //       };
  //     });
  //   } else {
  //     setSelectedFilters((prev) => {
  //       return {
  //         ...prev,
  //         [value]: prev[value].filter((i) => i !== item),
  //       };
  //     });
  //   }
  // }
  function handleCheck(item, e) {
    const { checked } = e.target;

    // Handle the single select scenario
    if (!isSelectMultiple) {
      if (checked) {
        setSelectedFilters((prev) => ({ ...prev, [value]: [item] }));
      }
      // Optionally handle the uncheck case for single select
      return;
    }

    // Below is the logic for multiple select, executed only if isSelectMultiple is true
    if (checked) {
      setSelectedFilters((prev) => ({
        ...prev,
        [value]: [...prev[value], item],
      }));
    } else {
      setSelectedFilters((prev) => ({
        ...prev,
        [value]: prev[value].filter((i) => i !== item),
      }));
    }
  }

  return (
    <div className="category-filter">
      <h4 className="category-filter__header">{title}</h4>
      <div className="category-filter__body">
        {items.map((item, index) => {
          const single_item_vlue = item.value;
          const name = item.name;
          return (
            <div className="category-filter__item" data-selected={selectedFilters[value]?.includes(single_item_vlue)} key={value + single_item_vlue}>
              <input
                type="checkbox"
                id={value + single_item_vlue}
                checked={selectedFilters[value]?.includes(single_item_vlue) || false}
                onChange={(e) => handleCheck(single_item_vlue, e)}
              />
              <label
                style={{
                  textTransform: "capitalize",
                }}
                htmlFor={value + single_item_vlue}
              >
                {name}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
}
